import React from "react";
import OrOpeningPodcastWidget from "../../../components/OrOpeningPodcastWidget";

const OpeningPodcast = props => <OrOpeningPodcastWidget {...props} />;

export default OpeningPodcast;
